/* RS Garage search ranking.
   House-brand products are pinned ahead of everyone else.
   A query that names a part is limited to that Shopify product type so
   "crankshaft" does not also return main bearings, pulleys, and camshafts. */
(function () {
  const RSG_PARTS = [
    {
      type: 'Blow Off Valves',
      phrases: ['blow off valves', 'blow off valve', 'blowoff valve', 'bov'],
      strong: ['blow off', 'blowoff', 'bov'],
    },
    {
      type: 'Camshafts',
      phrases: ['camshafts', 'camshaft', 'cams'],
      strong: ['camshaft', 'cam shaft'],
    },
    {
      type: 'Clutches',
      phrases: ['clutches', 'clutch'],
      strong: ['clutch'],
    },
    {
      type: 'Connecting Rods',
      phrases: ['connecting rods', 'connecting rod', 'conrods', 'conrod'],
      strong: ['connecting rod', 'conrod'],
    },
    {
      type: 'Crankshafts',
      phrases: ['crankshafts', 'crankshaft', 'crank shafts', 'crank shaft', 'cranks', 'crank'],
      strong: ['crankshaft', 'crank shaft'],
    },
    {
      type: 'Flywheels',
      phrases: ['flywheels', 'flywheel'],
      strong: ['flywheel'],
    },
    {
      type: 'Gaskets',
      phrases: ['gaskets', 'gasket'],
      strong: ['gasket'],
    },
    {
      type: 'Injectors',
      phrases: ['fuel injectors', 'fuel injector', 'injectors', 'injector'],
      strong: ['injector'],
    },
    {
      type: 'Main Bearings',
      phrases: ['main bearings', 'main bearing', 'mains'],
      strong: ['main bearing'],
    },
    {
      type: 'Pistons',
      phrases: ['pistons', 'piston'],
      strong: ['piston'],
    },
    {
      type: 'Rod Bearings',
      phrases: ['rod bearings', 'rod bearing'],
      strong: ['rod bearing'],
    },
    {
      type: 'Turbochargers',
      phrases: ['turbochargers', 'turbocharger', 'turbos', 'turbo'],
      strong: ['turbo'],
    },
    {
      type: 'Valve Covers',
      phrases: ['valve covers', 'valve cover'],
      strong: ['valve cover'],
    },
    {
      type: '',
      phrases: [
        'crank pulley',
        'crank pulleys',
        'crank damper',
        'crank dampener',
        'harmonic balancer',
        'valve spring',
        'valve springs',
        'valve seal',
        'valve seals',
        'valve guide',
        'valve guides',
        'valve lock',
        'valve locks',
        'piston ring',
        'piston rings',
        'piston pin',
        'turbo blanket',
        'turbo kit',
        'turbo kits',
        'turbo manifold',
        'head gasket',
        'valve cover gasket',
        'clutch kit',
        'clutch kits',
      ],
      strong: [],
    },
  ];

  const STOP = new Set(['for', 'the', 'and', 'with', 'oem', 'rsg']);
  const pinHtmlCache = new Map();
  const ladderHtmlCache = new Map();
  let pinToken = 0;

  /* First match wins. Edit this list to change who follows RS Garage. */
  const RSG_VENDOR_LADDER = [
    ['rsgarage'],
    ['briancrower'],
    ['manley', 'manleyperformance'],
    ['cpcarrillo', 'carrillorods', 'carrillo'],
    ['boostline'],
    ['kelford', 'kelfordcams'],
    ['ferrea'],
    ['supertech'],
    ['arp'],
    ['wiseco'],
    ['arias'],
    ['motec'],
  ];

  function rsgNormalizeQuery(value) {
    return String(value || '')
      .replace(/\s*product_type:"[^"]*"/gi, ' ')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Part words map to custom.sub_category, which is the part type.
     A brand phrase opens that vendor's collection so the full catalog is reachable. */
  const RSG_SHELF_LABELS = [
    'Air Intake Systems',
    'Intake Manifolds',
    'Throttle Bodies',
    'Catback Exhausts',
    'Turbo Manifolds',
    'Pistons',
    'Rods',
    'Rod Bearings',
    'Main Bearings',
    'Thrust Washers',
    'Timing Belts',
    'Timing Gear',
    'Studs & Bolts',
    'Engine Dressup',
    'Crankshafts',
    'Billet Main Caps',
    'Crank Pulleys/Dampers',
    'Sleeves',
    'Oil Pumps',
    'Oil Pans',
    'Dry Sump Kits',
    'Water Pumps',
    'Engine & Transmission Mounts',
    'Oil Catch Cans',
    'Camshafts',
    'Valves',
    'Valvesprings & Retainers',
    'Cam Gears',
    'Valve Guides',
    'Valve Seals',
    'Valve Locks / Keepers',
    'Head Gaskets',
    'Other Gaskets',
    'Fuel Pumps',
    'Injectors',
    'Fuel Rails',
    'Fuel Pressure Regulators',
    'Turbochargers',
    'Intercoolers',
    'Wastegates',
    'Blow Off Valves',
    'Clutches',
    'Flywheels',
    'Radiators',
    'Radiator Hoses',
    'Oil Coolers',
    'Coilovers',
    'Front Wheels',
    'Rear Wheels',
    'Front Skinnies',
    'Tires',
    'Lug Nuts & Studs',
  ];

  const RSG_SHELF_ALIASES = {
    Pistons: ['piston'],
    Rods: ['connecting rod', 'connecting rods', 'conrod', 'conrods'],
    'Rod Bearings': ['rod bearing'],
    'Main Bearings': ['main bearing', 'mains'],
    Crankshafts: ['crankshaft', 'crank shaft', 'crank shafts', 'cranks', 'crank'],
    Camshafts: ['camshaft', 'cam shaft', 'cams', 'cam'],
    'Blow Off Valves': ['blow off valve', 'blowoff valve', 'blow off', 'bov'],
    Turbochargers: ['turbocharger', 'turbos', 'turbo'],
    Clutches: ['clutch'],
    Flywheels: ['flywheel'],
    Injectors: ['fuel injector', 'fuel injectors', 'injector'],
    'Head Gaskets': ['head gasket'],
    'Valve Guides': ['valve guide'],
    'Valve Seals': ['valve seal'],
    'Valve Locks / Keepers': ['valve lock', 'valve locks', 'keepers'],
    'Valvesprings & Retainers': ['valve spring', 'valve springs', 'valvespring', 'valvesprings'],
    Tires: ['tire', 'tyre', 'tyres'],
    'Front Wheels': ['front wheel'],
    'Rear Wheels': ['rear wheel'],
    'Front Skinnies': ['front skinny', 'skinnies', 'skinny'],
    'Lug Nuts & Studs': ['lug nut', 'lug nuts', 'lug studs'],
    'Oil Pans': ['oil pan'],
    'Fuel Pumps': ['fuel pump'],
    'Timing Belts': ['timing belt'],
    'Crank Pulleys/Dampers': ['crank pulley', 'crank pulleys', 'harmonic balancer', 'crank damper'],
  };

  function rsgShelfPhrase(value) {
    return rsgNormalizeQuery(value);
  }

  function rsgBuildShelves() {
    const shelves = [
      {
        values: ['Wheels'],
        phrases: ['wheels', 'wheel', 'rims', 'rim'].map(rsgShelfPhrase),
        handle: 'wheels',
      },
    ];
    RSG_SHELF_LABELS.forEach((label) => {
      const phrases = [rsgShelfPhrase(label)];
      if (!/[&/]/.test(label)) {
        const lower = rsgShelfPhrase(label);
        if (lower.endsWith('s')) phrases.push(lower.slice(0, -1));
        else phrases.push(`${lower}s`);
      }
      (RSG_SHELF_ALIASES[label] || []).forEach((phrase) => phrases.push(rsgShelfPhrase(phrase)));
      shelves.push({
        values: [label],
        phrases: phrases.filter((phrase, index) => phrase && phrases.indexOf(phrase) === index),
      });
    });
    return shelves;
  }

  const RSG_SHELVES = rsgBuildShelves();
  const rsgCollectionCache = new Map();

  function rsgHandleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function rsgMatchShelf(raw) {
    const human = rsgNormalizeQuery(raw);
    if (!human) return null;
    const padded = ` ${human} `;
    let best = null;
    RSG_SHELVES.forEach((shelf) => {
      shelf.phrases.forEach((phrase) => {
        const idx = padded.indexOf(` ${phrase} `);
        if (idx === -1) return;
        if (!best || phrase.length > best.phrase.length || (phrase.length === best.phrase.length && idx < best.idx)) {
          best = { shelf, phrase, idx, human };
        }
      });
    });
    if (!best) return { brand: human, values: [], handle: '', human };
    const brand = human.replace(best.phrase, ' ').replace(/\s+/g, ' ').trim();
    return {
      brand,
      values: best.shelf.values,
      handle: best.shelf.handle || '',
      human,
    };
  }

  function rsgCollectionExists(handle, vendorHandle) {
    if (!handle || !vendorHandle) return Promise.resolve(false);
    const cacheKey = `${handle}|${vendorHandle}`;
    if (rsgCollectionCache.has(cacheKey)) return Promise.resolve(rsgCollectionCache.get(cacheKey));
    let stored = null;
    try {
      stored = sessionStorage.getItem(`rsg-col:${cacheKey}`);
    } catch (e) {
      stored = null;
    }
    if (stored === '1' || stored === '0') {
      const ok = stored === '1';
      rsgCollectionCache.set(cacheKey, ok);
      return Promise.resolve(ok);
    }
    return fetch(`/collections/${handle}/products.json?limit=5`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((json) => {
        const products = (json && json.products) || [];
        const ok = products.some((product) => rsgHandleize(product.vendor) === vendorHandle);
        rsgCollectionCache.set(cacheKey, ok);
        try {
          sessionStorage.setItem(`rsg-col:${cacheKey}`, ok ? '1' : '0');
        } catch (e) {}
        return ok;
      })
      .catch(() => false);
  }

  function rsgShelfUrl(handle, values, query) {
    const params = new URLSearchParams();
    params.set('rsg_search', '1');
    if (query) params.set('rsg_q', query);
    (values || []).forEach((value) => {
      if (value) params.append('filter.p.m.custom.sub_category', value);
    });
    const qs = params.toString();
    return `/collections/${handle}${qs ? `?${qs}` : ''}`;
  }

  function rsgPartOnlyUrl(values, human) {
    const params = new URLSearchParams();
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('q', values.length === 1 ? values[0] : human);
    values.forEach((value) => {
      if (value) params.append('filter.p.m.custom.sub_category', value);
    });
    return `/search?${params.toString()}`;
  }

const RSG_BRANDS = [
    { handle: "radium-brand", phrases: ["radium", "radium brand"] },
    { handle: "hps", phrases: ["hps"] },
    { handle: "insane-shafts", phrases: ["insane shafts"] },
    { handle: "fuel-injector-clinic", phrases: ["fic fuel injector clinic", "fuel injector clinic", "fic"] },
    { handle: "driven-racing-oil", phrases: ["driven oil", "driven racing oil", "driven racing", "driven"] },
    { handle: "rs-garage-products", phrases: ["rs garage", "rs garage products", "rsg", "rsgarage"] },
    { handle: "synchrotech", phrases: ["synchrotech"] },
    { handle: "trend-performance", phrases: ["trend performance", "trend"] },
    { handle: "boostline", phrases: ["boostline"] },
    { handle: "powerhouse-racing", phrases: ["powerhouse", "powerhouse racing"] },
    { handle: "precision-turbo", phrases: ["precision turbo", "precision"] },
    { handle: "garrett", phrases: ["garrett"] },
    { handle: "fluidampr-1", phrases: ["fluidampr"] },
    { handle: "diamond-pistons", phrases: ["diamond", "diamond pistons"] },
    { handle: "acl", phrases: ["acl"] },
    { handle: "motec-1", phrases: ["motec", "mo tec"] },
    { handle: "turbosmart", phrases: ["turbosmart"] },
    { handle: "link-ecu", phrases: ["link ecu", "link"] },
    { handle: "xs-power", phrases: ["xs power", "xs"] },
    { handle: "pure-turbos", phrases: ["pure turbos", "pure"] },
    { handle: "arias-pistons", phrases: ["arias", "arias pistons"] },
    { handle: "haltech", phrases: ["haltech"] },
    { handle: "csf-race", phrases: ["csf", "csf race"] },
    { handle: "wiseco", phrases: ["wiseco"] },
    { handle: "je-pistons", phrases: ["je pistons", "je"] },
    { handle: "tomei", phrases: ["tomei"] },
    { handle: "supertech-1", phrases: ["supertech"] },
    { handle: "injector-dynamics", phrases: ["injector dynamics"] },
    { handle: "arp-1", phrases: ["arp"] },
    { handle: "deatschwerks", phrases: ["deatschwerks", "deatsch werks", "dw"] },
    { handle: "manley-performance", phrases: ["manley", "manley performance"] },
    { handle: "cp-carillo", phrases: ["cp carillo", "carrillo", "cp carrillo", "c p carrillo"] },
    { handle: "brian-crower-2", phrases: ["brian crower"] },
    { handle: "kelford", phrases: ["kelford"] },
    { handle: "ferrea", phrases: ["ferrea"] },
    { handle: "yukon", phrases: ["yukon"] },
    { handle: "yokohama", phrases: ["yokohama"] },
    { handle: "wilwood", phrases: ["wilwood"] },
    { handle: "whiteline", phrases: ["whiteline"] },
    { handle: "wagner-tuning", phrases: ["wagner tuning", "wagner"] },
    { handle: "vossen", phrases: ["vossen"] },
    { handle: "volant", phrases: ["volant"] },
    { handle: "vibrant", phrases: ["vibrant"] },
    { handle: "torque-solution", phrases: ["torque solution"] },
    { handle: "titan-fuel-tanks", phrases: ["titan fuel tanks", "titan fuel"] },
    { handle: "ticon-industries", phrases: ["ticon industries", "ticon"] },
    { handle: "tial", phrases: ["tial"] },
    { handle: "tein", phrases: ["tein"] },
    { handle: "superpro", phrases: ["superpro"] },
    { handle: "stainless-works", phrases: ["stainless works", "stainless"] },
    { handle: "stainless-bros", phrases: ["stainless bros", "stainless"] },
    { handle: "st-suspensions", phrases: ["st suspensions"] },
    { handle: "ssr", phrases: ["ssr"] },
    { handle: "spl-parts", phrases: ["spl parts", "spl"] },
    { handle: "spectre", phrases: ["spectre"] },
    { handle: "spec", phrases: ["spec"] },
    { handle: "spc", phrases: ["spc"] },
    { handle: "sparco", phrases: ["sparco"] },
    { handle: "spal", phrases: ["spal"] },
    { handle: "snow-performance", phrases: ["snow performance", "snow"] },
    { handle: "seibon", phrases: ["seibon"] },
    { handle: "rywire", phrases: ["rywire"] },
    { handle: "rs-r", phrases: ["rs r"] },
    { handle: "roush", phrases: ["roush"] },
    { handle: "rigid", phrases: ["rigid"] },
    { handle: "remus", phrases: ["remus"] },
    { handle: "recaro", phrases: ["recaro"] },
    { handle: "rays", phrases: ["rays"] },
    { handle: "racequip", phrases: ["racequip"] },
    { handle: "race-star", phrases: ["race star"] },
    { handle: "qtp", phrases: ["qtp"] },
    { handle: "qa1", phrases: ["qa1"] },
    { handle: "pure-drivetrain", phrases: ["pure drivetrain"] },
    { handle: "project-mu", phrases: ["project mu"] },
    { handle: "peterson-fluid-systems", phrases: ["peterson fluid systems", "peterson fluid"] },
    { handle: "perrin", phrases: ["perrin"] },
    { handle: "os-giken", phrases: ["os giken"] },
    { handle: "nitrous-express", phrases: ["nitrous express"] },
    { handle: "moroso", phrases: ["moroso"] },
    { handle: "michelin", phrases: ["michelin"] },
    { handle: "method", phrases: ["method"] },
    { handle: "mcleod", phrases: ["mcleod"] },
    { handle: "mcgard", phrases: ["mcgard"] },
    { handle: "kraftwerks", phrases: ["kraftwerks"] },
    { handle: "kartboy", phrases: ["kartboy"] },
    { handle: "k-n", phrases: ["k n", "kn", "k and n"] },
    { handle: "isr", phrases: ["isr"] },
    { handle: "invidia", phrases: ["invidia"] },
    { handle: "innovative-mounts", phrases: ["innovative mounts", "innovative"] },
    { handle: "innovate-motorsports", phrases: ["innovate", "innovate motorsports"] },
    { handle: "injen", phrases: ["injen"] },
    { handle: "hp-tuners", phrases: ["hp tuners", "hptuners"] },
    { handle: "hks", phrases: ["hks"] },
    { handle: "hawk", phrases: ["hawk"] },
    { handle: "h-r", phrases: ["h r", "hr", "h and r"] },
    { handle: "greddy", phrases: ["greddy"] },
    { handle: "gram-lights", phrases: ["gram lights"] },
    { handle: "goodridge", phrases: ["goodridge"] },
    { handle: "girodisc", phrases: ["girodisc"] },
    { handle: "gfb", phrases: ["gfb"] },
    { handle: "fuelab", phrases: ["fuelab"] },
    { handle: "forgestar", phrases: ["forgestar"] },
    { handle: "ford-racing", phrases: ["ford racing", "ford"] },
    { handle: "forced-performance", phrases: ["forced performance", "forced"] },
    { handle: "fidanza", phrases: ["fidanza"] },
    { handle: "enkei", phrases: ["enkei"] },
    { handle: "energy-suspension", phrases: ["energy suspension"] },
    { handle: "eibach", phrases: ["eibach"] },
    { handle: "ebc", phrases: ["ebc"] },
    { handle: "eagle", phrases: ["eagle"] },
    { handle: "dba", phrases: ["dba"] },
    { handle: "cusco", phrases: ["cusco"] },
    { handle: "corsa", phrases: ["corsa"] },
    { handle: "competition-clutch", phrases: ["competition clutch"] },
    { handle: "clutch-masters", phrases: ["clutch masters"] },
    { handle: "brembo", phrases: ["brembo"] },
    { handle: "borla", phrases: ["borla"] },
    { handle: "borgwarner", phrases: ["borgwarner", "borg warner"] },
    { handle: "bmr", phrases: ["bmr"] },
    { handle: "bilstein", phrases: ["bilstein"] },
    { handle: "bfgoodrich", phrases: ["bfgoodrich", "bf goodrich", "bfg"] },
    { handle: "belak", phrases: ["belak"] },
    { handle: "bbs", phrases: ["bbs"] },
    { handle: "baja-designs", phrases: ["baja designs"] },
    { handle: "baer", phrases: ["baer"] },
    { handle: "antigravity", phrases: ["antigravity"] },
    { handle: "ams-performance", phrases: ["ams performance", "ams"] },
    { handle: "alcon", phrases: ["alcon"] },
    { handle: "akrapovic", phrases: ["akrapovic"] },
    { handle: "afe", phrases: ["afe", "a fe"] },
    { handle: "advan", phrases: ["advan"] },
    { handle: "hybrid", phrases: ["hybrid racing", "hybrid"] },
    { handle: "exedy", phrases: ["exedy"] },
    { handle: "weld-1", phrases: ["weld"] },
    { handle: "koyo", phrases: ["koyo"] },
    { handle: "fragola", phrases: ["fragola"] },
    { handle: "motul", phrases: ["motul"] },
    { handle: "gates", phrases: ["gates"] },
    { handle: "toyo", phrases: ["toyo"] },
    { handle: "blox-racing", phrases: ["blox racing", "blox"] },
    { handle: "mickey-thompson", phrases: ["mickey thompson"] },
    { handle: "aeromotive", phrases: ["aeromotive"] },
    { handle: "do88-performance", phrases: ["do88", "do88 performance", "do 88"] },
    { handle: "cometic-1", phrases: ["cometic"] },
    { handle: "mishimoto", phrases: ["mishimoto"] },
    { handle: "king-bearings", phrases: ["king bearings", "king"] },
    { handle: "gsc-power-division", phrases: ["gsc power division", "gsc power", "gsc"] },
  ];

  function rsgMatchKnownBrand(human) {
    const padded = ` ${human} `;
    let best = null;
    RSG_BRANDS.forEach((brand) => {
      brand.phrases.forEach((phrase) => {
        const idx = padded.indexOf(` ${phrase} `);
        if (idx === -1) return;
        if (!best || phrase.length > best.phrase.length || (phrase.length === best.phrase.length && idx < best.idx)) {
          best = { brand, phrase, idx };
        }
      });
    });
    if (!best) return null;
    return {
      handle: best.brand.handle,
      rest: human.replace(best.phrase, ' ').replace(/\s+/g, ' ').trim(),
    };
  }

  function rsgResolveShelf(raw) {
    const human = rsgRewriteQuery(raw).human;
    if (!human || rsgLooksLikePartNumber(human)) return Promise.resolve(null);
    const known = rsgMatchKnownBrand(human);
    if (known) {
      const part = known.rest ? rsgMatchShelf(known.rest) : null;
      const partValues = part && !(part.brand || '').trim() ? part.values || [] : [];
      return Promise.resolve(rsgShelfUrl(known.handle, partValues, human));
    }
    const match = rsgMatchShelf(human);
    const brandHandle = rsgHandleize(match.brand);
    const values = match.values || [];
    if (!brandHandle) {
      if (!values.length) return Promise.resolve(null);
      return Promise.resolve(rsgPartOnlyUrl(values, match.human || human));
    }
    const checks = [];
    if (values.length === 1) checks.push(`${brandHandle}-${rsgHandleize(values[0])}`);
    checks.push(`${brandHandle}-1`);
    checks.push(brandHandle);

    return checks.reduce((chain, handle) => {
      return chain.then((found) => {
        if (found) return found;
        return rsgCollectionExists(handle, brandHandle).then((ok) => {
          if (!ok) return null;
          const catalog = handle === brandHandle || handle === `${brandHandle}-1`;
          return rsgShelfUrl(handle, catalog ? values : [], match.human || human);
        });
      });
    }, Promise.resolve(null)).then((found) => {
      if (found) return found;
      if (!values.length) return null;
      return rsgPartOnlyUrl(values, match.human || human);
    });
  }

  function rsgClearShelfPending() {
    document.documentElement.classList.remove('rsg-shelf-pending');
  }

  function rsgBareQuery(value) {
    return String(value || '')
      .replace(/\s*product_type:"[^"]*"/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function rsgSamePlace(dest) {
    try {
      const next = new URL(dest, window.location.origin);
      const herePath = window.location.pathname.replace(/\/+$/, '') || '/';
      const nextPath = next.pathname.replace(/\/+$/, '') || '/';
      if (nextPath !== herePath) return false;
      const left = new URLSearchParams(next.search);
      const right = new URLSearchParams(window.location.search);
      const keys = new Set([...left.keys(), ...right.keys()]);
      for (const key of keys) {
        if (key === 'q') {
          if (rsgBareQuery(left.get('q')) !== rsgBareQuery(right.get('q'))) return false;
          continue;
        }
        const a = left.getAll(key).map((value) => value.toLowerCase()).sort().join('\n');
        const b = right.getAll(key).map((value) => value.toLowerCase()).sort().join('\n');
        if (a !== b) return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function rsgMatchPart(raw) {
    const human = rsgNormalizeQuery(raw);
    if (!human) return null;
    const padded = ` ${human} `;
    let winner = null;
    RSG_PARTS.forEach((part) => {
      part.phrases.forEach((phrase) => {
        if (!padded.includes(` ${phrase} `)) return;
        if (!winner || phrase.length > winner.phrase.length) winner = { part, phrase };
      });
    });
    if (!winner) return null;
    return {
      type: winner.part.type || '',
      part: winner.part,
      phrase: winner.phrase,
      human,
    };
  }

  function rsgLooksLikePartNumber(value) {
    const text = String(value || '').trim();
    if (!text || /\s/.test(text)) return false;
    return /[0-9]/.test(text) || text.includes('-');
  }

  function rsgRewriteQuery(raw) {
    const human = String(raw || '')
      .replace(/\s*product_type:"[^"]*"/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (rsgLooksLikePartNumber(human)) return { human, submitted: human, match: null };
    const match = rsgMatchPart(human);
    if (!match || !match.type) return { human, submitted: human, match };
    return {
      human,
      submitted: `${human} product_type:"${match.type}"`.replace(/\s+/g, ' ').trim(),
      match,
    };
  }

  function rsgNormalizeVendor(vendor) {
    return String(vendor || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function rsgVendorTier(vendor) {
    const key = rsgNormalizeVendor(vendor);
    if (!key) return 100;
    for (let i = 0; i < RSG_VENDOR_LADDER.length; i += 1) {
      if (RSG_VENDOR_LADDER[i].indexOf(key) !== -1) return i;
    }
    return 100;
  }

  function rsgIsHouseVendor(vendor) {
    return rsgNormalizeVendor(vendor) === 'rsgarage';
  }

  function rsgHouseTitleOk(title, match, human) {
    const norm = rsgNormalizeQuery(title);
    if (match && match.type && match.part && match.part.strong && match.part.strong.length) {
      return match.part.strong.some((phrase) => norm.includes(phrase));
    }
    const tokens = rsgNormalizeQuery(human)
      .split(' ')
      .filter((token) => token.length >= 3 && !STOP.has(token));
    if (!tokens.length) {
      const compact = rsgNormalizeQuery(human).replace(/\s/g, '');
      return compact === 'rsg' || compact === 'rsgarage' || rsgNormalizeQuery(human) === 'rs garage';
    }
    return tokens.every((token) => {
      if (norm.includes(token)) return true;
      if (token.endsWith('s') && norm.includes(token.slice(0, -1))) return true;
      return norm.includes(`${token}s`);
    });
  }

  function rsgSearchRelevanceScore(sku, vendor, title, tokens) {
    const skuNorm = String(sku || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
    const vendorNorm = String(vendor || '').toLowerCase();
    const titleNorm = String(title || '').toLowerCase();
    let score = 0;
    const list = tokens || [];

    list.forEach((token) => {
      const compact = token.replace(/[^a-z0-9]/g, '');
      if (!compact || compact === 'product' || compact === 'type') return;

      let hit = false;
      if (skuNorm === compact) {
        score += 200;
        hit = true;
      } else if (compact !== 'rsg' && compact.length >= 3 && skuNorm.startsWith(compact)) {
        score += 120;
        hit = true;
      } else if (compact !== 'rsg' && compact.length >= 3 && skuNorm.includes(compact)) {
        score += 70;
        hit = true;
      }

      if (vendorNorm.includes(token) || vendorNorm.replace(/[^a-z0-9]/g, '') === compact) {
        score += 25;
        hit = true;
      }
      if (titleNorm.includes(token)) {
        score += 12;
        hit = true;
      }
      if (!hit && compact.length >= 4) score -= 50;
    });

    const human = list.join(' ');
    const match = rsgMatchPart(human);
    const tier = rsgVendorTier(vendor);
    if (tier === 0 && rsgHouseTitleOk(title, match, human)) score += 100000;
    else if (tier < 100) score += (100 - tier) * 1000;

    if (match && match.type === 'Valve Covers' && !rsgIsHouseVendor(vendor)) {
      if (/\b(fitting|grommet|hardware|gasket)\b/i.test(titleNorm) && !/\b(fitting|grommet|hardware|gasket)\b/.test(human)) {
        score -= 140;
      }
    }
    if (match && match.type === 'Crankshafts' && !rsgIsHouseVendor(vendor)) {
      if (/\b(bearing|bearings|pulley|pulleys|spacer|assembly|assemblies)\b/i.test(titleNorm)) score -= 140;
    }

    return score;
  }

  function rsgSearchUrl() {
    const predictive = window.routes && window.routes.predictive_search_url;
    if (predictive) return predictive.replace(/\/suggest\/?$/, '');
    return '/search';
  }

  function rsgFetchPinHtml(human, signal) {
    const key = human.toLowerCase();
    if (pinHtmlCache.has(key)) return Promise.resolve(pinHtmlCache.get(key));
    const pinQuery = /\brs\s*garage\b/i.test(human) ? human : `RS Garage ${human}`;
    const url =
      `${rsgSearchUrl()}?q=${encodeURIComponent(pinQuery)}` +
      '&type=product&options%5Bprefix%5D=last' +
      `&filter.p.vendor=${encodeURIComponent('RS Garage')}` +
      '&sections=rsg-search-pin';
    return fetch(url, { signal, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then((json) => {
        const html = json['rsg-search-pin'] || '';
        pinHtmlCache.set(key, html);
        return html;
      });
  }

  function rsgFilterPinNodes(nodes, human) {
    const match = rsgMatchPart(human);
    return nodes
      .filter((node) => rsgIsHouseVendor(node.getAttribute('data-rsg-vendor')) && rsgHouseTitleOk(node.getAttribute('data-rsg-title'), match, human))
      .slice(0, 8);
  }

  function rsgApplyPins(list, nodes, prepend) {
    if (!list || !nodes.length) return;
    const handles = new Set(nodes.map((node) => node.getAttribute('data-rsg-handle')).filter(Boolean));
    list.querySelectorAll('[data-rsg-handle]').forEach((item) => {
      const handle = item.getAttribute('data-rsg-handle');
      if (item.hasAttribute('data-rsg-pinned') || (handle && handles.has(handle))) item.remove();
    });
    if (!prepend) return;
    const fragment = document.createDocumentFragment();
    nodes.forEach((node) => {
      node.setAttribute('data-rsg-pinned', 'true');
      fragment.appendChild(node);
    });
    list.insertBefore(fragment, list.firstChild);
  }

  function rsgRerankGrid() {
    const list = document.querySelector('#product-grid ul.product-grid');
    if (!list) return;
    const params = new URLSearchParams(window.location.search);
    const tokens = rsgNormalizeQuery(params.get('q') || '').match(/[a-z0-9]+/g);
    if (!tokens || tokens.length < 1) return;
    const items = Array.from(list.children).filter((item) => item.hasAttribute('data-rsg-sku') || item.hasAttribute('data-rsg-title'));
    if (items.length < 2) return;
    const scored = items.map((item, index) => ({
      item,
      index,
      score: rsgSearchRelevanceScore(
        item.getAttribute('data-rsg-sku'),
        item.getAttribute('data-rsg-vendor'),
        item.getAttribute('data-rsg-title'),
        tokens
      ),
    }));
    scored.sort((a, b) => b.score - a.score || a.index - b.index);
    scored.forEach(({ item }) => list.appendChild(item));
  }

  function rsgPinResultsGrid() {
    const params = new URLSearchParams(window.location.search);
    const human = rsgRewriteQuery(params.get('q') || '').human;
    if (!human || !document.querySelector('#product-grid')) return;
    const token = ++pinToken;
    const search = window.location.search;
    const page = Number(params.get('page') || '1');
    rsgFetchPinHtml(human)
      .then((html) => {
        if (token !== pinToken || window.location.search !== search) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = rsgFilterPinNodes(Array.from(doc.querySelectorAll('[data-rsg-pin-card]')), human);
        const list = document.querySelector('#product-grid ul.product-grid');
        if (!list) return;
        rsgApplyPins(list, cards, page <= 1);
      })
      .catch(() => {});
  }

  function rsgEnsurePredictiveList(root) {
    let list = root.querySelector('#predictive-search-results-products-list');
    if (list) return list;
    const results = root.querySelector('#predictive-search-results') || root;
    const group = document.createElement('div');
    group.className = 'predictive-search__result-group';
    group.innerHTML =
      '<div><h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>' +
      '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products"></ul></div>';
    const anchor = results.querySelector('.predictive-search__search-for-button, [data-predictive-search-search-for-text]');
    if (anchor && anchor.parentElement) {
      results.insertBefore(group, anchor.parentElement.closest('div') || anchor);
    } else {
      results.appendChild(group);
    }
    return group.querySelector('ul');
  }

  function rsgPinPredictive(instance) {
    if (!instance || !instance.predictiveSearchResults) return;
    const human = rsgRewriteQuery(instance.searchTerm || instance.getQuery() || '').human;
    if (!human) return;
    const term = instance.searchTerm;
    rsgFetchPinHtml(human, instance.abortController && instance.abortController.signal)
      .then((html) => {
        if (instance.searchTerm !== term) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const rows = rsgFilterPinNodes(Array.from(doc.querySelectorAll('[data-rsg-pin-row]')), human);
        if (!rows.length) return;
        const list = rsgEnsurePredictiveList(instance.predictiveSearchResults);
        rsgApplyPins(list, rows, true);
      })
      .catch(() => {});
  }

  function rsgMaybeTightenSearchUrl() {
    if (!document.getElementById('product-grid') && !document.querySelector('.template-search')) return false;
    const params = new URLSearchParams(window.location.search);
    if ([...params.keys()].some((key) => key.indexOf('sub_category') !== -1 || key.indexOf('part_type') !== -1)) return false;
    const raw = params.get('q') || '';
    if (!raw || /product_type:"/i.test(raw)) return false;
    const rewritten = rsgRewriteQuery(raw);
    if (!rewritten.match || !rewritten.match.type || rewritten.submitted === raw) return false;
    params.set('q', rewritten.submitted);
    window.location.replace(`${window.location.pathname}?${params.toString()}`);
    return true;
  }

  function rsgOnSearchSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.rsgBypass === '1') return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;
    if (form.querySelector('[aria-selected="true"] a, button[aria-selected="true"]')) return;
    const raw = input.value;
    if (rsgLooksLikePartNumber(String(raw || '').trim())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    rsgResolveShelf(raw).then((dest) => {
      if (dest) {
        window.location.assign(dest);
        return;
      }
      const rewritten = rsgRewriteQuery(raw);
      const params = new URLSearchParams(new FormData(form));
      if (rewritten.match && rewritten.match.type && rewritten.submitted !== rewritten.human) {
        params.set('q', rewritten.submitted);
      }
      const action = form.getAttribute('action') || rsgSearchUrl();
      window.location.assign(`${action}?${params.toString()}`);
    });
  }

  function rsgCleanSearchChrome() {
    const kept = new URLSearchParams(window.location.search).get('rsg_q') || '';
    document.querySelectorAll('input[type="search"][name="q"]').forEach((input) => {
      if (!input.value && kept) {
        input.value = kept;
        const reset = input.parentElement && input.parentElement.querySelector('.rsg-header-search__reset');
        if (reset) reset.classList.remove('hidden');
      }
      const human = rsgRewriteQuery(input.value).human;
      if (human && human !== input.value) input.value = human;
    });
    if (/product_type:/i.test(document.title)) {
      document.title = document.title.replace(/\s*product_type:"[^"]*"/gi, '').replace(/""/g, '"');
    }
  }

  function rsgProductList() {
    const grid = document.getElementById('product-grid');
    if (!grid) return null;
    if (grid.tagName === 'UL') return grid;
    return grid.querySelector('ul.product-grid');
  }

  function rsgLadderEnabled() {
    const sort = new URLSearchParams(window.location.search).get('sort_by') || '';
    return !/^(price|title|created)/.test(sort);
  }

  function rsgSortListByVendor(list) {
    if (!list) return;
    const tokens = rsgNormalizeQuery(new URLSearchParams(window.location.search).get('q') || '').match(/[a-z0-9]+/g);
    const ranked = Array.from(list.children).map((item, index) => ({
      item,
      index,
      tier: rsgVendorTier(item.getAttribute('data-rsg-vendor')),
      score: tokens
        ? rsgSearchRelevanceScore(
            item.getAttribute('data-rsg-sku'),
            item.getAttribute('data-rsg-vendor'),
            item.getAttribute('data-rsg-title'),
            tokens
          )
        : 0,
    }));
    ranked.sort((a, b) => a.tier - b.tier || b.score - a.score || a.index - b.index);
    ranked.forEach(({ item }) => list.appendChild(item));
  }

  function rsgLadderVendorNames() {
    const checked = document.querySelectorAll('input[name="filter.p.vendor"]:checked');
    if (checked.length) return [];
    const seen = new Set();
    const names = [];
    document.querySelectorAll('input[name="filter.p.vendor"]').forEach((input) => {
      const name = input.value;
      if (!name || seen.has(name) || rsgVendorTier(name) === 100) return;
      seen.add(name);
      names.push(name);
    });
    names.sort((a, b) => rsgVendorTier(a) - rsgVendorTier(b));
    return names;
  }

  function rsgFetchVendorSection(vendorName, signal) {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set('filter.p.vendor', vendorName);
    url.searchParams.set('sections', 'rsg-vendor-pin');
    const key = `${url.pathname}?${url.searchParams.toString()}`;
    if (ladderHtmlCache.has(key)) return Promise.resolve(ladderHtmlCache.get(key));
    return fetch(url.toString(), { signal, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then((json) => {
        const html = json['rsg-vendor-pin'] || '';
        ladderHtmlCache.set(key, html);
        return html;
      });
  }

  function rsgRefreshGridOrder() {
    if (window.location.pathname.indexOf('/search') === -1) return;
    const refreshKey = window.location.pathname + window.location.search;
    if (rsgRefreshGridOrder.lastKey === refreshKey) return;
    rsgRefreshGridOrder.lastKey = refreshKey;
    if (!rsgLadderEnabled()) return;
    const list = rsgProductList();
    if (!list) return;
    rsgSortListByVendor(list);

    const params = new URLSearchParams(window.location.search);
    const human = rsgRewriteQuery(params.get('q') || '').human;
    const onSearch = window.location.pathname.indexOf('/search') !== -1;
    const vendors = rsgLadderVendorNames().filter((name) => !(onSearch && human && rsgIsHouseVendor(name)));
    const jobs = vendors.map((name) =>
      rsgFetchVendorSection(name)
        .then((html) => ({ name, html, house: false }))
        .catch(() => ({ name, html: '', house: false }))
    );
    if (onSearch && human) {
      jobs.unshift(
        rsgFetchPinHtml(human)
          .then((html) => ({ name: 'RS Garage', html, house: true }))
          .catch(() => ({ name: 'RS Garage', html: '', house: true }))
      );
    }
    if (!jobs.length) return;

    const token = ++pinToken;
    const search = window.location.search;
    const page = Number(params.get('page') || '1');
    Promise.all(jobs).then((groups) => {
      if (token !== pinToken || window.location.search !== search) return;
      const listNow = rsgProductList();
      if (!listNow) return;
      const cards = [];
      groups
        .sort((a, b) => rsgVendorTier(a.name) - rsgVendorTier(b.name))
        .forEach((group) => {
          if (!group.html) return;
          const doc = new DOMParser().parseFromString(group.html, 'text/html');
          let nodes = Array.from(doc.querySelectorAll('[data-rsg-pin-card]'));
          if (group.house) nodes = rsgFilterPinNodes(nodes, human);
          nodes.forEach((node) => cards.push(node));
        });
      if (!cards.length) return;
      rsgApplyPins(listNow, cards, page <= 1);
      rsgSortListByVendor(listNow);
    });
  }

  function rsgKeepSearchShelf() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('rsg_search') !== '1') return;
    const kept = params.get('rsg_q') || '';
    document.documentElement.classList.add('rsg-show-part-chips');
    document.querySelectorAll('a.rsg-part-chip, a.rsg-flat-part, a.active-facets__button, a.active-facets__button-remove').forEach((link) => {
      try {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        let changed = false;
        if (url.searchParams.get('rsg_search') !== '1') {
          url.searchParams.set('rsg_search', '1');
          changed = true;
        }
        if (kept && url.searchParams.get('rsg_q') !== kept) {
          url.searchParams.set('rsg_q', kept);
          changed = true;
        }
        if (changed) link.setAttribute('href', `${url.pathname}${url.search}`);
      } catch (error) {}
    });
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, #FacetSortDrawerForm').forEach((form) => {
      if (!form.querySelector('input[name="rsg_search"]')) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'rsg_search';
        input.value = '1';
        form.appendChild(input);
      }
      if (kept && !form.querySelector('input[name="rsg_q"]')) {
        const query = document.createElement('input');
        query.type = 'hidden';
        query.name = 'rsg_q';
        query.value = kept;
        form.appendChild(query);
      }
    });
  }

  document.addEventListener('submit', rsgOnSearchSubmit, true);

  function rsgCorrectBrandCollection() {
    const path = window.location.pathname.replace(/\/+$/, '');
    const marker = '/collections/';
    if (path.indexOf(marker) === -1) return false;
    const params = new URLSearchParams(window.location.search);
    const kept = params.get('rsg_q') || '';
    if (!kept) return false;
    const human = rsgRewriteQuery(kept).human;
    const known = human ? rsgMatchKnownBrand(human) : null;
    if (!known) return false;
    const currentHandle = path.slice(path.indexOf(marker) + marker.length).split('/')[0];
    if (!currentHandle || currentHandle === known.handle) return false;
    const part = known.rest ? rsgMatchShelf(known.rest) : null;
    const partValues = part && !(part.brand || '').trim() ? part.values || [] : [];
    const dest = rsgShelfUrl(known.handle, partValues, human);
    if (rsgSamePlace(dest)) return false;
    window.location.replace(dest);
    return true;
  }

  document.addEventListener('DOMContentLoaded', () => {
    rsgCleanSearchChrome();
    if (rsgCorrectBrandCollection()) return;
    const onSearch = window.location.pathname.replace(/\/+$/, '').slice(-7) === '/search';
    const route = onSearch ? rsgResolveShelf(new URLSearchParams(window.location.search).get('q') || '') : Promise.resolve(null);
    route.then((dest) => {
      if (dest && !rsgSamePlace(dest)) {
        window.location.replace(dest);
        return;
      }
      rsgClearShelfPending();
      if (rsgMaybeTightenSearchUrl()) return;
      rsgRefreshGridOrder();
    });
    rsgKeepSearchShelf();
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    const observer = new MutationObserver(() => {
      rsgKeepSearchShelf();
      rsgRefreshGridOrder();
    });
    observer.observe(container, { childList: true });
  });

  window.rsgRewriteQuery = rsgRewriteQuery;
  window.rsgSearchRelevanceScore = rsgSearchRelevanceScore;
  window.rsgPinPredictive = rsgPinPredictive;
})();
